export default __webpack_public_path__ + "static/media/iphone-x.c4a964e6.png";